import { render, staticRenderFns } from "./TheWallTab.vue?vue&type=template&id=abfaee60&scoped=true&"
import script from "./TheWallTab.vue?vue&type=script&lang=js&"
export * from "./TheWallTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abfaee60",
  null
  
)

export default component.exports